import type { TProductTypeTabId } from 'entities/creditForm';

import { PRODUCT_TYPE_TAB_ITEMS } from '../../config';
import { useProductTypeSelection } from '../../lib/useProductTypeSelection';
import { ProductTypeCardList } from '../ProductTypeCardList/ProductTypeCardList';

type TProductTypeSelectionProps = {
  activeTabId?: TProductTypeTabId;
  onSelectTab?: (tabId: TProductTypeTabId) => void;
};

const isControlledSelection = (
  props: TProductTypeSelectionProps,
): props is Required<Pick<TProductTypeSelectionProps, 'activeTabId' | 'onSelectTab'>> =>
  props.activeTabId !== undefined && props.onSelectTab !== undefined;

const ProductTypeSelectionUncontrolled = () => {
  const { activeTabId, onSelectTab, tabs } = useProductTypeSelection();

  return (
    <ProductTypeCardList
      tabs={tabs}
      activeTabId={activeTabId}
      onSelectTab={onSelectTab}
    />
  );
};

export const ProductTypeSelection = (props: TProductTypeSelectionProps = {}) => {
  if (isControlledSelection(props)) {
    return (
      <ProductTypeCardList
        tabs={PRODUCT_TYPE_TAB_ITEMS}
        activeTabId={props.activeTabId}
        onSelectTab={props.onSelectTab}
      />
    );
  }

  return <ProductTypeSelectionUncontrolled />;
};
